<div class="login-page">
  <!-- Left brand panel (desktop) / hero (mobile) -->
  <aside class="login-brand">
    <div class="login-brand__pattern" aria-hidden="true"></div>
    <div class="login-brand__arcs" aria-hidden="true"></div>

    <div class="login-brand__top">
      <div class="login-brand__mark">
        <span class="material-icons">local_parking</span>
      </div>
      <p class="login-brand__eyebrow">CityParking Admin</p>
      <h1 class="login-brand__title">
        สวัสดี CityParking!
      </h1>
      <p class="login-brand__desc login-brand__desc--desktop">
        ระบบบริหารลานจอดรถครบวงจร — จัดการบัตรจอด EV ชาร์จ
        และการบริการลูกค้าในที่เดียว ลดงานซ้ำซ้อนด้วยระบบอัตโนมัติ
      </p>
      <p class="login-brand__desc login-brand__desc--mobile">
        ระบบบริหารลานจอด · บัตรจอด · EV ชาร์จ
      </p>
    </div>

    <div class="login-brand__features">
      <div class="login-feature">
        <span class="material-icons">ev_station</span>
        <span>มอนิเตอร์สถานี EV แบบเรียลไทม์</span>
      </div>
      <div class="login-feature">
        <span class="material-icons">badge</span>
        <span>จัดการบัตรจอดและสมาชิก</span>
      </div>
      <div class="login-feature">
        <span class="material-icons">support_agent</span>
        <span>ติดตามเคสบริการลูกค้า</span>
      </div>
    </div>

    <p class="login-brand__copy">
      © {{ currentYear }} CityParking · Powered by PSS
    </p>
  </aside>

  <!-- Right form panel -->
  <section class="login-form-panel">
    <div class="login-form-sheet">
      <div class="login-form-inner">
        <div class="login-form-brand">
          <img src="img/logo.png" alt="CityParking" class="login-form-logo" />
        </div>

        <div class="login-form-header">
          <h2>{{ heading }}</h2>
          <p>{{ subheading }}</p>
        </div>

        <form (ngSubmit)="onSubmit()" class="login-form-fields">
          <div class="login-field">
            <label>Username</label>
            <div class="login-field__control">
              <span class="material-icons login-field__icon">person_outline</span>
              <input
                type="text"
                [(ngModel)]="username"
                name="username"
                autocomplete="username"
                placeholder="admin@company.com"
                [disabled]="isLoading || mode !== 'login'"
              />
            </div>
          </div>

          @if (mode === 'login' || needsCurrentPassword) {
            <div class="login-field">
              <label>{{ mode === 'change' ? 'รหัสผ่านปัจจุบัน' : 'Password' }}</label>
              <div class="login-field__control">
                <span class="material-icons login-field__icon">lock_outline</span>
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  [(ngModel)]="password"
                  name="password"
                  autocomplete="current-password"
                  placeholder="••••••••"
                  [disabled]="isLoading"
                  class="login-field__input--password"
                />
                <button
                  type="button"
                  (click)="togglePassword()"
                  [disabled]="isLoading"
                  class="login-field__eye"
                  [attr.aria-label]="showPassword ? 'ซ่อนรหัสผ่าน' : 'แสดงรหัสผ่าน'"
                  [title]="showPassword ? 'ซ่อนรหัสผ่าน' : 'แสดงรหัสผ่าน'"
                >
                  <span class="material-icons">
                    {{ showPassword ? 'visibility_off' : 'visibility' }}
                  </span>
                </button>
              </div>
            </div>
          }

          @if (mode === 'first' || mode === 'change') {
            <div class="login-field">
              <label>รหัสผ่านใหม่</label>
              <div class="login-field__control">
                <span class="material-icons login-field__icon">lock_outline</span>
                <input
                  [type]="showNewPassword ? 'text' : 'password'"
                  [(ngModel)]="newPassword"
                  name="newPassword"
                  autocomplete="new-password"
                  placeholder="รหัสผ่านใหม่"
                  [disabled]="isLoading"
                  class="login-field__input--password"
                />
                <button
                  type="button"
                  (click)="toggleNewPassword()"
                  [disabled]="isLoading"
                  class="login-field__eye"
                  [attr.aria-label]="showNewPassword ? 'ซ่อนรหัสผ่าน' : 'แสดงรหัสผ่าน'"
                >
                  <span class="material-icons">
                    {{ showNewPassword ? 'visibility_off' : 'visibility' }}
                  </span>
                </button>
              </div>
            </div>

            <div class="login-field">
              <label>ยืนยันรหัสผ่านใหม่</label>
              <div class="login-field__control">
                <span class="material-icons login-field__icon">lock_outline</span>
                <input
                  [type]="showConfirmPassword ? 'text' : 'password'"
                  [(ngModel)]="confirmPassword"
                  name="confirmPassword"
                  autocomplete="new-password"
                  placeholder="ยืนยันรหัสผ่านใหม่"
                  [disabled]="isLoading"
                  class="login-field__input--password"
                />
                <button
                  type="button"
                  (click)="toggleConfirmPassword()"
                  [disabled]="isLoading"
                  class="login-field__eye"
                  [attr.aria-label]="showConfirmPassword ? 'ซ่อนรหัสผ่าน' : 'แสดงรหัสผ่าน'"
                >
                  <span class="material-icons">
                    {{ showConfirmPassword ? 'visibility_off' : 'visibility' }}
                  </span>
                </button>
              </div>
            </div>
          }

          <button type="submit" [disabled]="isLoading" class="login-submit">
            @if (isLoading) {
              <span class="login-submit__spinner" aria-hidden="true"></span>
              กำลังดำเนินการ...
            } @else if (mode === 'first') {
              <span class="material-icons text-[18px]">lock_reset</span>
              ตั้งรหัสผ่านและเข้าสู่ระบบ
            } @else if (mode === 'change') {
              <span class="material-icons text-[18px]">lock_reset</span>
              เปลี่ยนรหัสผ่าน
            } @else {
              <span class="material-icons text-[18px]">login</span>
              เข้าสู่ระบบ
            }
          </button>

          @if (mode !== 'login') {
            <button
              type="button"
              (click)="backToLogin()"
              [disabled]="isLoading"
              class="login-back"
            >
              กลับไปหน้าเข้าสู่ระบบ
            </button>
          }
        </form>

        <div class="login-form-footer">
          <p>การเข้าถึงโดยไม่ได้รับอนุญาตถือเป็นความผิด</p>
          <p class="login-form-footer__ver">v{{ appVersion || '—' }}</p>
        </div>
      </div>
    </div>
  </section>
</div>

<app-pss-alert-modal
  *ngIf="isAlertOpen"
  [title]="alertTitle"
  [message]="alertMessage"
  [variant]="alertVariant"
  confirmLabel="ตกลง"
  (close)="closeAlert()">
</app-pss-alert-modal>

<app-pss-loading *ngIf="isLoading" text="กำลังดำเนินการ" detail="โปรดรอสักครู่ . . ."></app-pss-loading>
